<template lang="pug">
  div
    h2
      | Kommentar eingeben
    div.px-4.py-4
      div.mb-1
        | Hier können Sie einen Kommentar zu Ihrer Bestellung hinterlassen:
      div
        textarea.form-control(
          v-model="notes"
          rows="5"
          :disabled="ordering")
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'OrderNotes',
  computed: {
    ...mapState('orderForm', [
      'orderNotes'
    ]),
    ...mapState({
      ordering: state => !!state.orderFormService.loadingIndicators.createOrder
    }),
    notes: {
      get () {
        return this.orderNotes
      },
      set (newVal) {
        this.setOrderNotes(newVal)
      }
    }
  },
  methods: {
    ...mapMutations('orderForm', [
      'setOrderNotes'
    ])
  }
}
</script>
